export default __webpack_public_path__ + "static/media/howItWorksUpload.e9eca26d.svg";